import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  apply_job_candidate_action,
  get_all_jobs_user_action,
  get_job_details_user_action,
  update_candidate_profile_action,
  get_candidate_profile_data_action,
  get_mentor_profile_data_action,
  update_mentor_profile_action,
  apply_job_mentor_action,
  search_job_action,
  user_meta_data_action,
  update_user_meta_data_action,
} from "../../../redux/_actions";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";

function useJobBoardExpanded(props) {
  const [allJobs, setAllJobs] = useState([]);
  const [jobDetails, setJobDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [jobDetailsLoading, setJobDetailsLoading] = useState(false);
  const [jobApplyLoading, setJobApplyLoading] = useState(false);
  const [formSubmitError, setFormSubmitError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [jobId, setJobId] = useState(null);
  const [show, setShow] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [fieldsShown, setFieldsShown] = useState({});
  const [formData, setFormData] = useState({});
  const [jobCoverLetter, setJobCoverLetter] = useState(null);
  const [jobResume, setJobResume] = useState(null);
  const [showSearch, setShowSearch] = useState(false);
  const [jobLoading, setJobLoading] = useState(false);
  const [jobSearch, setJobSearch] = useState(null);
  const [editResumeClicked, setEditResumeClicked] = useState(false);
  const [jobApplyModal, setJobApplyModal] = useState(false);
  const [isResumeLoading, setIsResumeLoading] = useState(false);
  const [isPrfoileUpdateLoading, setIsProfileUpdateLoading] = useState(false);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const jobCardDivParentRef = useRef(null);
  const searchInputRef = useRef();

  const { jobDetailsData } = useSelector(
    (state) => state.get_job_details_user_reducer
  );

  const { userMetaData } = useSelector((state) => state.user_meta_data_reducer);

  const { userProfileData } = useSelector(
    (state) => state.get_candidate_profile_data_reducer
  );
  const { mentorProfileData } = useSelector(
    (state) => state.get_mentor_profile_data_reducer
  );

  const { jobSearchDataList } = useSelector(
    (state) => state.search_job_reducer
  );

  useEffect(() => {
    getUserMeta();
  }, []);

  useEffect(() => {
    if (userMetaData) {
      getUserProfile();
    }
  }, [userMetaData]);

  useEffect(() => {
    if (currentPage !== null) {
      callApi();
    }
  }, [currentPage]);

  useEffect(() => {
    if (jobSearchDataList?.data) {
      setJobSearch(jobSearchDataList?.data);
    }
  }, [jobSearchDataList]);

  //get page number
  useEffect(() => {
    const index = location?.state && location.state?.index;
    if (index) {
      let pageNum = Math.floor(index / 10) + 1;
      setCurrentPage(pageNum);
    }
  }, []);

  useEffect(() => {
    if (jobSearchDataList?.data) {
      setAllJobs(jobSearchDataList?.data);
    }
  }, [jobSearchDataList]);

  //get jobId
  useEffect(() => {
    const job_id = location?.state && location.state?.job_id;
    if (job_id) {
      setJobId(job_id);
    }
  }, []);

  //get current job or job on zero number
  useEffect(() => {
    if (jobId) {
      onCurrentJobCardChange(jobId);
    } else if (jobId === null) {
      if (jobSearchDataList?.data) {
        let id = jobSearchDataList.data[0] && jobSearchDataList.data[0]?.id;
        onCurrentJobCardChange(id);
      }
    }
  }, [jobSearchDataList, jobId]);

  useEffect(() => {
    if (mentorProfileData?.data) {
      setUserInfo(mentorProfileData?.data);
      setJobResume(mentorProfileData);
    }
    if (userProfileData?.data) {
      setUserInfo(userProfileData?.data);
    }
  }, [mentorProfileData, userProfileData]);

  useEffect(() => {
    if (userInfo && userInfo.user_details) {
      setJobResume(
        userInfo?.user_details &&
          userInfo.user_details?.user_meta_info &&
          userInfo.user_details.user_meta_info?.resume
      );
    }
  }, [userInfo]);

  useEffect(() => {
    if (jobDetailsData?.data) {
      //set job details
      setJobDetails(jobDetailsData?.data);

      //   //for form schema
      //   let fields = {};
      //   let formData = jobDetailsData?.data;

      //   for (var key in formData) {
      //     let newKey = key.replace("application_form_", "");
      //     newKey = newKey.replace("_required", "");
      //     if (formData[key] === "mandatory" || formData[key] === "optional") {
      //       fields[newKey] = formData[key];
      //     }
      //   }
      //   fields["resume"] = "mandatory";

      //   setFieldsShown(fields);
    }
  }, [jobDetailsData]);

  const getUserMeta = async () => {
    await dispatch(user_meta_data_action());
  };

  const callApi = async () => {
    const data = {
      index: "job_posting",
      search_key: "",
      search: "",
      employment_type: [],
      experience: [],
      country: [],
      skill_names: [],
    };
    setLoading(true);
    await dispatch(search_job_action(data));
    setLoading(false);
  };

  const getUserProfile = async () => {
    if (userMetaData?.role === "candidate") {
      await dispatch(get_candidate_profile_data_action());
    } else if (userMetaData?.role === "mentor") {
      await dispatch(get_mentor_profile_data_action());
    }
  };

  const onCurrentJobCardChange = async (id) => {
    setJobDetailsLoading(true);
    setFormSubmitError({});
    setJobApplyLoading(false);
    await dispatch(get_job_details_user_action(id));
    setJobDetailsLoading(false);
  };

  const onCurrentPageChange = (page) => {
    setCurrentPage(page);
    setJobId(null);
  };

  const handleClose = (val) => {
    if (val) {
      setFormSubmitError({});
      dispatch(get_all_jobs_user_action());
      setJobId(null);
      setShow(!show);
    } else {
      setShow(!show);
    }
  };

  const onProfileUpdate = async (e) => {
    const name = e.target.name;
    const value = e.target.value;
    let data = {};
    data[name] = value;
    if (value.length > 0) {
      setIsProfileUpdateLoading(true);
      if (userMetaData?.role === "candidate") {
        await dispatch(update_candidate_profile_action(data));
        getUserProfile();
      } else if (userMetaData?.role === "mentor") {
        await dispatch(update_mentor_profile_action(data));
        getUserProfile();
      }
    }
    setIsProfileUpdateLoading(false);
  };

  const onSubmitForm = async (e) => {
    var role = userMetaData?.role;
    var headline = userInfo?.headline;
    var resume =
      userInfo?.user_details &&
      userInfo.user_details?.user_meta_info &&
      userInfo.user_details.user_meta_info?.resume;
    let validated = headline && resume;
    if (validated === null) {
      showWarningMessage("please update resume and headline");
      return;
    }
    if (role === "mentor") {
      setJobApplyLoading(true);
      await dispatch(apply_job_mentor_action(jobDetails?.id));
    } else if (role === "candidate") {
      const data = new FormData();
      data["summary"] = formData?.summary;
      setJobApplyLoading(true);
      await dispatch(apply_job_candidate_action(data, jobDetails?.id));
    }
    await dispatch(get_job_details_user_action(jobId));
    setJobApplyLoading(false);
    setJobApplyModal(false);
  };

  const onFormDataChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    let data = formData;
    data[name] = value;
    setFormData(data);
  };

  const onViewCompany = (id) => {
    navigate(`/company-info/${id}`, {
      state: {
        companyId: id,
      },
    });
  };

  const onResumeEditClick = () => setEditResumeClicked(!editResumeClicked);

  const onResumeUpload = async (e, key) => {
    const file = e.target.files[0];
    const name = e.target.name;
    const data = new FormData();

    data.append(name, file);
    if (file) {
      if (file && file.type === "application/pdf") {
        setJobResume(file);
        setIsResumeLoading(true);
        await dispatch(update_user_meta_data_action(data));

        getUserProfile();
        setIsResumeLoading(false);
      } else {
        showWarningMessage("Please select a PDF file.");
      }
    } else {
      showWarningMessage("Resume Need to Uploaded");
    }
    setEditResumeClicked(false);
  };

  const onApplyClick = () => {
    if(!userMetaData){
      navigate('/sign-in');
    }
    else setJobApplyModal(!jobApplyModal);
  };
  const onBackClick = () => {
    navigate(-1);
  }

  return {
    allJobs,
    loading,
    jobDetails,
    jobDetailsLoading,
    jobApplyLoading,
    formSubmitError,
    currentPage,
    userInfo,
    fieldsShown,
    formData,
    jobCardDivParentRef,
    userMetaData,
    jobSearch,
    jobLoading,
    showSearch,
    jobApplyModal,
    isResumeLoading,
    isPrfoileUpdateLoading,
    onCurrentJobCardChange,
    onCurrentPageChange,
    handleClose,
    onProfileUpdate,
    onFormDataChange,
    onSubmitForm,
    onViewCompany,
    onResumeUpload,
    editResumeClicked,
    onResumeEditClick,
    onApplyClick,
    onBackClick
  };
}
export default useJobBoardExpanded;
